import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { CustomEntityUtils } from './../../../custom-entity-utils.service';
import { parse,parseISO } from 'date-fns'
import { CustomEntityService } from './../../../apiclient/api/customEntity.service';
import { UserSessionService } from './../../../UserSession/user-session.service';
@Component({
  selector: 'ngx-historico-dialog',
  templateUrl: './historico-dialog.component.html',
  styleUrls: ['./historico-dialog.component.scss']
})
export class HistoricoDialogComponent implements OnInit {

  loading = false;
  elementId:any;
  snapshot:any = {}
  constructor(protected dialogRef: NbDialogRef<any>,private customEntityUtils: CustomEntityUtils,
    private customEntityService: CustomEntityService,private userSessionService: UserSessionService,
    private nbToastrService: NbToastrService) { }

  async ngOnInit() {

      this.snapshot.workingfrom = parseISO((await this.customEntityUtils.getCurrentEntity()).createdAt);
      this.snapshot.workinguntil = new Date();
  }


  moverHistorico() {
    this.loading=true;
    this.customEntityService.snapshotelement(this.elementId,{workingFrom:this.snapshot.workingfrom,workingUntil:this.snapshot.workinguntil},this.userSessionService.accessToken).subscribe(async (result) => {
        console.log(result)
        this.nbToastrService.success('El histórico del elemento se ha credo con éxito.','Histórico de elemento');
        (await this.customEntityUtils.getCurrentEntity()).elements.push(result)
        this.loading=false;
        this.dialogRef.close();
    },error => {
        console.log(error)
        if(error.error != undefined){
          this.nbToastrService.danger(error.error.details,error.error.message);
        }else{
          this.nbToastrService.danger('No se ha podido crear el histórico del elemento. Consulte con el administrador','Error al crear histórico');
        }

        this.loading=false;
    })

  }

  cerrar() {
      this.dialogRef.close();
    }

}


